import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import { getListItems } from '../../public/utility'
import MethodDeviceDetailDiv from './MethodDeviceDetailDiv'
import SelectMethodDetail from './SelectMethodDetail'
class MethodApplyDetail extends React.Component {
    state = {
        applyType: this.props.applyType,
        id: this.props.id,
        processing: 0,//限制并发操作
        onlyView: this.props.onlyView || false,
    }

    componentDidMount = () => {
        const { id } = this.props
        this.GetMethodApply(id)
    }

    GetMethodApply = (id) => {
        Tyan.doPostEvent({
            event: 'GetMethodApply',
            data: { id },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
                setTimeout(this.handelFinish, 100)
            }
        })
    }
    handelBegin = () => this.setState((state) => ({ processing: state.processing + 1 }))
    handelFinish = () => this.setState((state) => ({ processing: state.processing - 1 }))

    handlerClose = () => {
        const { onClose, onSave } = this.props
        onClose && onClose()
        onSave && onSave()
    }

    handlerSave = () => {
        const { id, changedValues基本信息, applyType } = this.state
        if (!Tyan.utility.getFormValue(this, '基本信息', '标准编号')) {
			Ext.toast("标准编号 不能为空！"); return
		}
        if (!Tyan.utility.getFormValue(this, '基本信息', '新项目说明')) {
			Ext.toast("拟展开新项目说明 不能为空！"); return
		}
        if (!Tyan.utility.getFormValue(this, '基本信息', '原因说明')) {
			Ext.toast("原因说明 不能为空！"); return
		}
        Tyan.doPostEvent({
            event: 'SaveMethodApply',
            data: { id, applyType, changedValues基本信息, },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage, id }) => {
                setTimeout(this.handelFinish, 100)
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    this.GetMethodApply(id)
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteMethodApply',
                data: { id },
                onRequest: this.handelBegin,
                onEnd: ({ errorMessage }) => {
                    setTimeout(this.handelFinish, 100)
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerAddMethodDevice = () => {
        const { id, changedValues基本信息, applyType } = this.state

        Tyan.doPostEvent({
            event: 'SaveMethodApply',
            data: { id, applyType, changedValues基本信息, },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage, id, methodID }) => {
                setTimeout(this.handelFinish, 100)
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id, methodID })
                    Tyan.pubForm.showDialog('项目检测设备', MethodDeviceDetailDiv, { id: 0, methodID, bReadOnly: false, onSave: () => this.GetMethodApply(id) })
                }
            }
        })
    }

    handlerEditMethodDevice = (iMethodDeviceID) => {
        const { id, initValues基本信息, changedValues基本信息, applyType, onlyView } = this.state
        const { 状态名称 } = initValues基本信息

        Tyan.doPostEvent({
            event: 'SaveMethodApply',
            data: { id, applyType, changedValues基本信息, },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage, id, methodID }) => {
                setTimeout(this.handelFinish, 100)
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id, methodID })
                    Tyan.pubForm.showDialog('项目检测设备', MethodDeviceDetailDiv, { id: iMethodDeviceID, methodID, bReadOnly: (状态名称 !== '申请中' && 状态名称 !== '方法验证') || onlyView === true, onSave: () => this.GetMethodApply(id) })
                }
            }
        })
    }

    handlerSelectMethod = () => {
        const { id } = this.state
        Tyan.pubForm.showDialog('选择检测方法', SelectMethodDetail, {
            id, onSave: (v) => {
                Tyan.utility.changeItemsValue(this, '基本信息',
                    ['检测方法'], [v]
                );
                this.handlerSave(id)
            }
        })
    }


    bChanged = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return hasChangedValues(this) && values.标准编号 !== '' && values.新项目说明 !== '' && values.原因说明 !== ''
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息, applyType, onlyView } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        const { 状态名称 } = initValues基本信息
        const { list } = getListItems(this, '基本信息', '使用设备')
        return [
            { _text: '委托单编号', name: '申请编号', minWidth: '45%', disabled: true },
            { _text: '申请状态', name: '状态名称', minWidth: '45%', disabled: true },
            { _text: '申请人', name: '创建人', minWidth: '45%', disabled: true },
            { _date: '申请日期', name: '创建时间', minWidth: '45%', disabled: true },
            { _text: '拟展开新项目说明', name: '新项目说明', required: true, minWidth: '90%', maxRows: 3, },
            { _text: '原因说明', name: '原因说明', required: true, minWidth: '90%', maxRows: 3, },
            { _files: '附件', minWidth: '90%', },
            {
                _group: '', minWidth: '90%', margin: 0, padding: '0 0 0 0', cdt: () => applyType === '修改' || values.申请类型 === '修改', items: [
                    { _text: '检测方法', name: '检测方法', minWidth: '70%', disabled: true, required: true },
                    {
                        _buttons: [
                            { _button: '选择...', ui: '', margin: '0px 15px 0px 0px', handler: this.handlerSelectMethod, cdt: () => (状态名称 === '申请中' || 状态名称 === '方法验证') && onlyView === false },
                        ], width: null, margin: 0
                    }
                ]
            },
            // { _select: '检测方法', minWidth: '90%', editable: true, forceSelection: false, onChange: (v) => this.handlerSelectMethod(v), cdt: () => applyType === '修改' || values.申请类型 === '修改' },
            { _select: '标准编号', minWidth: '90%', required: true, editable: true, forceSelection: false },
            { _text: '标准名称', minWidth: '90%' },
            { _text: '英文方法名称', minWidth: '90%' },
            { _checkbox: '报告上显示实际取样信息', name: '报告显示实际取样信息', items: [['', '是']], minWidth: '40%' },
            { _select: '关联大方法', minWidth: '90%', editable: true, forceSelection: false },
            { _date: '方法查新时间', minWidth: '45%' },
            { _select: '是否作废', name: '作废标识', options: ['否', '是'], minWidth: '45%' },
            {
                _grid: '使用设备', name: '使用设备', rowNumbers: true, minRows: 1, maxRows: list ? list.length : 1, minWidth: '90%',
                columns: [
                    { _text: '设备信息', minWidth: '90%' },
                ],
                buttons: [
                    { _button: '添加...', /* icon: 'plus', */  handler: () => this.handlerAddMethodDevice(), cdt: () => (状态名称 === '申请中' || 状态名称 === '方法验证') && onlyView === false },
                ],
                onDoubleTap: data => this.handlerEditMethodDevice(data.id)
            },
            { _int: '排列顺序', name: '排序', minWidth: '90%', textAlign: 'left' },
            { _select: '原始记录', name: '原始记录名称', minWidth: '90%', editable: true, forceSelection: false },
            { _files: '中文流程图', minWidth: '90%', multiple: false, accept: 'image/*' },
            { _files: '英文流程图', minWidth: '90%', multiple: false, accept: 'image/*' },
            { _files: '中英文流程图', minWidth: '90%', multiple: false, accept: 'image/*' },
            { _text: '备注', minWidth: '90%', maxRows: 3, },
        ]
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'bottom' } }]
    }

    fieldset签核流程 = () => {
        return [
            { _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'bottom' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { initValues基本信息, processing, id, onlyView } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态名称 } = initValues基本信息
        return <Body data={this} minWidth="900"
            controls={
                [
                    { _flow: 'MethodApplyFlow', disabled: this.bChanged() || processing, cdt: () => id > 0 && onlyView === false, id: this.state.id },
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged(), cdt: () => (状态名称 === '申请中' || 状态名称 === '方法验证') && onlyView === false },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && 状态名称 === '申请中' && onlyView === false, handler: this.handlerDelete, disabled: this.bChanged() },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: (状态名称 !== '申请中' && 状态名称 !== '方法验证') || onlyView === true, docked: 'top', height: '65%',/*   fullblock: true  */ },
                    {
                        _fieldsets: [
                            { title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
                            { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                        ], disabled: true, fullblock: true
                    },
                    // { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), disabled: true, fullblock: true },
                ]}
        />
    }
}

export default connect()(MethodApplyDetail)